import script from "./WCAutoplayCarouselModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCAutoplayCarouselModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCAutoplayCarouselModern.vue?vue&type=style&index=0&id=b2ed0b6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2ed0b6e"]])

export default __exports__